import React, { useContext, useMemo, useState } from 'react';
import ClassNames from 'classnames';
import { getDecade, getCenturyLabel, getYear } from '../../utils/dates';
import { formatMonthYear as defaultFormatMonthYear } from '../../utils/dateFormatter';
import language from '../../utils/language';
import CalendarPickerContext from '../../context/CalendarPickerContext';
import { CALENDAR_POSITION, VIEWS, PREV_BUTTON, NEXT_BUTTON, MONTH_BUTTON, YEAR_BUTTON, PRIMARY_YEAR_VIEW_YEAR_BUTTON, SECONDARY_YEAR_VIEW_YEAR_BUTTON } from '../../utils/constants';
import { getKeyTable } from '../../utils/NavUtils';
var Navigation = function Navigation(props) {
  var _props$navigationLayo = props.navigationLayoutMode,
    navigationLayoutMode = _props$navigationLayo === void 0 ? "default" : _props$navigationLayo,
    date = props.activeStartDate,
    drillUp = props.drillUp,
    navigationLabel = props.navigationLabel,
    keyboardControlArea = props.keyboardControlArea,
    view = props.view,
    disabled = props.disabled,
    showNavigationPrevNextBtn = props.showNavigationPrevNextBtn,
    calendarPosition = props.calendarPosition,
    locale = props.locale;
  var _useState = useState(new Map()),
    buttonRefMap = _useState[0];
  var _useContext = useContext(CalendarPickerContext),
    activeStartDateStore = _useContext.activeStartDateStore,
    activeStartDateDispatch = _useContext.activeStartDateDispatch;
  var onClickPrevious = function onClickPrevious(e) {
    var _getKeyTable = getKeyTable(e),
      isEnter = _getKeyTable.isEnter;
    if (e.type === 'click' || isEnter) {
      activeStartDateDispatch({
        type: 'goPrev',
        payload: {}
      });
    }
  };
  var onClickNext = function onClickNext(e) {
    var _getKeyTable2 = getKeyTable(e),
      isEnter = _getKeyTable2.isEnter;
    if (e.type === 'click' || isEnter) {
      activeStartDateDispatch({
        type: 'goNext',
        payload: {
          view: view
        }
      });
    }
  };
  var getLabel = function getLabel() {
    var inRight = calendarPosition === CALENDAR_POSITION.RIGHT;
    var date = inRight ? activeStartDateStore.activeStartDateRight : activeStartDateStore.activeStartDateLeft;
    if (!date) date = new Date();
    switch (view) {
      case 'century':
        return getCenturyLabel(date);
      case 'decade':
        return getDecade(language, locale);
      case 'year':
        return getYear(date);
      case 'month':
        return defaultFormatMonthYear(locale, date);
      default:
        throw new Error("Invalid view: " + view + ".");
    }
  };
  var label = useMemo(function () {
    return getLabel();
  }, [activeStartDateStore.activeStartDateLeft]);
  if (!date) date = new Date();
  var className = "ap-nav-bar";
  var prevCn = ClassNames("ap-nav-prev-button Appkit4-icon icon-left-chevron-outline");
  setTimeout(function () {
    if (buttonRefMap.get(keyboardControlArea)) {
      buttonRefMap.get(keyboardControlArea).focus();
    }
  }, 0);
  var prevButton = /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: 0,
    ref: function ref(_ref) {
      return buttonRefMap.set(PREV_BUTTON, _ref);
    },
    className: prevCn,
    onClick: onClickPrevious,
    onKeyDown: onClickPrevious,
    "aria-label": "previous " + (view === 'month' ? 'month' : view === 'year' ? 'year' : "")
  });
  var nextCn = ClassNames("ap-nav-next-button Appkit4-icon icon-right-chevron-outline");
  var nextButton = /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: 0,
    ref: function ref(_ref2) {
      return buttonRefMap.set(NEXT_BUTTON, _ref2);
    },
    className: nextCn,
    onClick: onClickNext,
    onKeyDown: onClickNext,
    "aria-label": "next " + (view === 'month' ? 'month' : view === 'year' ? 'year' : "")
  });
  var wrapperCn = ClassNames("a-center-button-wrapper", navigationLayoutMode);
  var naviLabel = navigationLabel ? navigationLabel({
    date: date,
    view: view,
    label: label
  }) : label;
  var centerCn = ClassNames({
    "a-center-button": !(label instanceof Array),
    "a-center-button-group": label instanceof Array,
    "a-center-text": naviLabel === "Select a year"
  });
  var centerMonthCn = ClassNames('ap-center-button-month');
  var centerYearCn = ClassNames('ap-center-button-year');
  var target = VIEWS.DECADE; //0 :decadeView, 1:yearView, 2:monthView
  var centerButton = /*#__PURE__*/React.createElement("div", {
    className: wrapperCn
  }, label instanceof Array ? /*#__PURE__*/React.createElement("div", {
    className: centerCn
  }, /*#__PURE__*/React.createElement("div", {
    tabIndex: 0,
    ref: function ref(_ref3) {
      return buttonRefMap.set(MONTH_BUTTON, _ref3);
    },
    className: centerMonthCn,
    onClick: disabled ? undefined : drillUp,
    role: "button"
  }, label[1]), /*#__PURE__*/React.createElement("div", {
    tabIndex: 0,
    ref: function ref(_ref4) {
      return buttonRefMap.set(YEAR_BUTTON, _ref4);
    },
    className: centerYearCn,
    onClick: disabled ? undefined : function (event) {
      return drillUp(event, target);
    },
    role: "button"
  }, label[0])) : function () {
    return /*#__PURE__*/React.createElement("div", {
      role: "button",
      className: centerCn,
      tabIndex: naviLabel === 'Select a year' ? -1 : 0,
      onClick: disabled || naviLabel === 'Select a year' ? undefined : drillUp,
      ref: function ref(_ref5) {
        var key = calendarPosition === 0 ? PRIMARY_YEAR_VIEW_YEAR_BUTTON : SECONDARY_YEAR_VIEW_YEAR_BUTTON;
        buttonRefMap.set(key, _ref5);
      }
    }, naviLabel);
  }());
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, centerButton, showNavigationPrevNextBtn && /*#__PURE__*/React.createElement("div", {
    className: "ap-nav-button-wrapper"
  }, prevButton, nextButton));
};
export default Navigation;